import {get} from '-/util/lodash';
import {Component, Fragment} from 'react';
import {connect} from 'react-redux';

import {
    getAllStipsForApplicantSelector,
    getNumberStipsToUploadSelector,
    oppositeApplicantNameSelector
} from '-/selectors';
import {getOppositeApplicant} from '-/util/util';
import Stip from '-/components/fields/Stip';
import NavigationService from '-/services/NavigationService';
import StipsHeader from '-/components/general/StipsHeader';
import StipDocStatus from '-/components/fields/StipDocStatus';
import Form from '-/components/fields/Form';
import Button from '-/components/general/Button';
import StipsService from '-/services/StipsService';
import {fetchInfo} from '-/actions/actions';
import UIService from '-/services/UIService';

class StipsList extends Component {
    componentDidMount() {
        const {applicantType, fetchInfo} = this.props;

        if (!applicantType) {
            StipsService.setApplicantType('app');
            UIService.setLoading(true);

            fetchInfo().then(() => {
                UIService.setLoading(false);
            }).catch(() => {
                UIService.setLoading(false);
            });
        }
    }

    renderButtons() {
        const {applicantType, stipSubmitted, coAppUnlocked, oppositeApplicantName} = this.props;
        const oppositeApplicantType = getOppositeApplicant(applicantType);

        return (
            <Fragment>
                {stipSubmitted && (
                    <Button onClick={() => NavigationService.next('stipsSubmitted')} btnStyle="main" className="main" tag="a">
                        Submit
                    </Button>
                )}
                {coAppUnlocked && (
                    <Button onClick={() => StipsService.setApplicantType(oppositeApplicantType)} btnStyle="alternate" className="main" tag="a">
                        Switch to {oppositeApplicantName}
                    </Button>
                )}
            </Fragment>
        );
    }

    renderStips() {
        const {stips, applicantType} = this.props;

        return (
            <div className="center">
                {stips.map(stip => {
                    const docs = stip.docs.map((doc, j) => {
                        if (doc.status === 'NOTREQUIRED') {
                            return null;
                        }

                        const key = `${stip.docType}_${applicantType}_${j}`;
                        const props = {
                            key,
                            stip,
                            doc
                        };

                        if (['VERIFIED', 'SUBMITTED', 'UNDERREVIEW'].indexOf(doc.status) > -1) {
                            return <StipDocStatus {...props} />;
                        } else {
                            return <Stip {...props} />;
                        }
                    });
                    return docs;
                })}
            </div>
        );
    }

    render() {
        return (
            <div className="stips-list">
                <Form standalone={true}>
                    <StipsHeader />
                    {this.renderStips()}
                    {this.renderButtons()}
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const applicantType = get(state, 'stips.applicantType');
    const {stipsUploadedThisSession} = getNumberStipsToUploadSelector(state);
    const stipSubmitted = stipsUploadedThisSession > 0;
    const stips = getAllStipsForApplicantSelector(state);
    const {coAppUnlocked} = state.navigation || {};
    const oppositeApplicantName = oppositeApplicantNameSelector(state);

    return {
        stips,
        applicantType,
        stipSubmitted,
        coAppUnlocked,
        oppositeApplicantName
    };
};

export default connect(mapStateToProps, {fetchInfo})(StipsList);
